import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios'
import auth from './module-auth'
// import createPersistedState from 'vuex-persistedstate'

import {API_URL} from "../config";
import router from '../main.js'

import axiosRetry from 'axios-retry'

axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

Vue.use(Vuex);

const initialState = () => ({
  loading: false,
  fetchloading: false,
  firstName: "",
  lastName: "",
  facilityList: [],
  inspections: [],
  menue: [{
      header: true,
      title: "Home/Impressum"
    },
    {
      href: "/",
      title: "Home",
      icon: "fa fa-home"
    },
    {
      header: true,
      title: "Anmeldung"
    },
    {
      title: "Registrierung/Anmelden",
      icon: "fa fa-user-circle ",
      child: [{
          href: "/login",
          title: "Anmelden",
          icon: "fa fa-sign-in-alt"
        },
        {
          href: "/register",
          title: "Registrierung",
          icon: "fa fa-registered"
        }
      ]
    },
    {
      href: "/AboutUs",
      title: "Impressum",
      icon: "fas fa-address-card"
    }
  ],
  inspectingRopeID: 0,
  inspectingRopeName: "",
  inspectingRopeType: "",
  inspectingFacilityID: 0,
  inspectingID: -1,
  ropeIDCounter: -1,
  facIDCoutner: -1,
  inspectionIDCounter: -1,
  isOnline: false,
  auth: {}
})

export const store = new Vuex.Store({
  modules: {
    auth
  },
  // plugins: [createPersistedState(
  //   {paths: ['auth']}
  // )],
  state: initialState,
  mutations: {
    setIDCounters(state, counters){
      state.ropeIDCounter = counters[0];
      state.facIDCoutner = counters[1];
      state.inspectionIDCounter = counters[2];
    },
    setUserData(state, userData){
      state.firstName = userData[0];
      state.lastName = userData[1];
    },
    setOnline(state) {
      state.isOnline = true;
    },
    setOffline(state) {
      state.isOnline = false;
    },
    updateMenue(state) {
      if (state.isOnline == true) {
        state.menue.push({
          href: "/Facilities",
          title: "Anlagen",
          icon: "fa fa-subway"
        });
        state.menue.push({
          href: "/EarlierInspections",
          title: "Vergangene Protokolle",
          icon: "fa fa-newspaper"
        });
        
        state.menue[3].child.splice(1, 1);
        // var o = state.menue.find(x => x.title == "")
        state.menue[3].child[0].title = "Logout";
        state.menue[3].child[0].href = "/logout";
      }else{
        state.menue[3].child[0].title = "Login";
        state.menue[3].child[0].href = "/Login";
        state.menue[3].child.push({
          href: "/register",
          title: "Registrierung",
          icon: "fa fa-registered"
        });
        state.menue.splice(state.menue.indexOf(5), 1)
        state.menue.splice(state.menue.indexOf(6), 1)
      }
    },
    addFacility(state, facility) {
      state.facilityList.push(facility)
    },
    setAddFacilityStarted(state, data){
      state.loading = true
    },
    setAddFacilitySuccessfull(state, data){
      state.loading = false
      let dat = data.input;
      dat.id = data.response.id
      store.commit("addFacility", dat)
    },
    setAddFacilityFailed(state, data){
      state.loading = false
    },


    addRopeToFacility(state, rope) {
      let index = state.facilityList.findIndex(x => x.id == rope.facility_id)
      state.facilityList[index].ropeList.push(rope)
    },
    setAddRopeToFacilityStarted(state, data){
      state.loading = true
    },
    setAddRopeToFacilitySuccessfull(state, data){
      console.log("data", data)
      state.loading = false
      let dat = data.input;
      dat.id = data.response.id

      store.commit("addRopeToFacility", dat)

  //   this.$store.commit("addRopeToFacility", [
  //     facilityIndex,
  //     {
  //       idRopeCounter: this.idRopeCounter,
  //       interval: "nicht festgelegt",
  //       rope: this.select,
  //       ropeN: this.ropeName.striped()
  //     }
  //   ]);
  // }

      // store.commit("addRopeToFacility", dat)
    },
    setAddRopeToFacilityFailed(state, data){
      state.loading = false
    },

    setInspectingRope(state, ropeFacilityID) {
      state.inspectingRopeID = ropeFacilityID[0]
      state.inspectingFacilityID = ropeFacilityID[1]
      state.inspectingRopeName = ropeFacilityID[2]
      state.inspectingRopeType = ropeFacilityID[3]
    },
    setInpectionID(state, inspectionID) {
      state.inspectingID = inspectionID
    },
    setInterval(state, intervall) {
      // todo update ropelist intervall
      state.facilityList.find(x => x.id == state.inspectingFacilityID).ropeList.find(x => x.id == state.inspectingRopeID).interval = intervall
    },
    addInspection(state, inspection) {
      var o = state.facilityList.find(x => x.id === state.inspectingFacilityID)
      var facilityName = o.name
      var ropeName = state.inspectingRopeName
      var ropeType = state.inspectingRopeType

      let data = {
        facName: facilityName,
        roName: ropeName,
        roType: ropeType,
        inspectionID: state.inspectingID,
        FacilityID: state.inspectingFacilityID,
        ropeID: state.inspectingRopeID,
        interval: inspection[0],
        date: inspection[1],
        assessText1: inspection[2],
        assessText2: inspection[3],
        assessText3: inspection[4],
        assessText4: inspection[5],
        assessText5: inspection[6],
        assessText6: inspection[7],
        assessText7: inspection[8],
        assessText8: inspection[9],
        assess1: inspection[10],
        assess2: inspection[11],
        assess3: inspection[12],
        assess4: inspection[13],
        assess5: inspection[14],
        assess6: inspection[15],
        assess7: inspection[16],
        assess8: inspection[17],
      }

      let ins = state.inspections.find(x => x.ropeID == state.inspectingRopeID)
      if (typeof ins === 'undefined') {
        state.inspections.push(data)
      } else {
        ins = data
      }
    },
    setAddInspectionToRopeStarted(state, data){
      state.loading = true
    },
    setAddInspectionToRopeSuccessfull(state, data){
      state.loading = false
      store.dispatch("fetchdata");
    },
    setAddInspectionToRopeFailed(state, data){
      state.loading = false
    },
    setUpdateRopeStarted(state, data){
      state.loading = true
    },
    setUpdateRopeSuccessfull(state, data){
      state.loading = false
    },
    setUpdateRopeFailed(state, data){
      state.loading = false
    },
    setFetchdataStarted(state, data){
      state.fetchloading = true
      state.loading = true
    },
    setFetchdataSuccessfull(state, data){
      state.fetchloading = false
      state.loading = false
      state.facilityList = data.response[0];
      state.inspections = data.response[1];
    },
    setFetchdataFailed(state, data){
      state.fetchloading = false
      state.loading = false
    },
    logout(state, data) {
      // const initial = initialState()
      // Object.keys(initial).forEach(key => { state[key] = initial[key] })
      store.commit("auth/logout");
      // state.auth = {}
      // axios.defaults.headers.common['Authorization'] = ''
      store.commit("setOffline");
      store.commit("updateMenue");
      router.push("/");
    },
    setDeleteFacStarted(state, data){
      state.loading = true
    },
    setDeleteFacSuccessfull(state, data){
      state.loading = false
      store.dispatch("fetchdata");
    },
    setDeleteFacFailed(state, data){
      state.loading = false
    },
    setDeleteRopeStarted(state, data){
      state.loading = true
    },
    setDeleteRopeSuccessfull(state, data){
      state.loading = false
      store.dispatch("fetchdata");
    },
    setDeleteRopeFailed(state, data){
      state.loading = false
    },
  },
  actions: {
    addFacility({ commit, dispatch }, data) {
      console.log('authing', data)
      commit('setAddFacilityStarted', data)
      let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.post(API_URL + '/be/facility/', sendData).then(function (response) {
        console.log('add fac: ', response)
        commit('setAddFacilitySuccessfull', { response: response.data, input: data })
        // commit("addFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setAddFacilityFailed', { data: data, error: error.response })
      })

      
    },

    addRopeToFacility({ commit, dispatch }, data) {
      console.log('addRopeToFacility', data)
      commit('setAddRopeToFacilityStarted', data)
      // let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.post(API_URL + '/be/facility/rope', data).then(function (response) {
        console.log('add fac: ', response)
        commit('setAddRopeToFacilitySuccessfull', { response: response.data, input: data })
        // commit("addAopeToFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setAddRopeToFacilityFailed', { data: data, error: error.response })
      })
    },

    updateRope({ commit, dispatch }, data) {
      console.log('updateRope', data)
      commit('setUpdateRopeStarted', data)
      // let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.put(API_URL + '/be/facility/rope/update/'+data.id, data).then(function (response) {
        console.log('add fac: ', response)
        commit('setUpdateRopeSuccessfull', { response: response.data, input: data })
        // commit("addAopeToFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setUpdateRopeFailed', { data: data, error: error.response })
      })
    },
    addInspectionToRope({ commit, dispatch}, data) {
      console.log('addInspectionToRope', data)
      commit('setAddInspectionToRopeStarted', data)
      // let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.post(API_URL + '/be/facility/rope/assessment', data).then(function (response) {
        console.log('add /be/facility/rope/assessment: ', response)
        commit('setAddInspectionToRopeSuccessfull', { response: response.data, input: data })
        // commit("addAopeToFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setAddInspectionToRopeFailed', { data: data, error: error.response })
      })
    },

    fetchdata({ commit, dispatch}, data) {
      console.log('fetchdata', data)

      let one = API_URL + '/be/facility/';
      let two = API_URL + '/be/facility/rope/assessment';
      const requestOne = axios.get(one);
      const requestTwo = axios.get(two);

      commit('setFetchdataStarted', data)

      axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
        const responseOne = responses[0]
        const responseTwo = responses[1]
        // use/access the results 
        console.log('fetch: ', responses)
        commit('setFetchdataSuccessfull', { response: [responses[0].data, responses[1].data], input: data })
      })).catch(error => {
        console.log('failed', error)
        commit('setFetchdataFailed', { data: data, error: error.response })
      })
    },

    deleteFac({ commit, dispatch}, data) {
      console.log('deleteFac', data)
      commit('setDeleteFacStarted', data)
      // let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.delete(API_URL + '/be/facility/remove/'+data, data).then(function (response) {
        console.log('deleteFac: ', response)
        commit('setDeleteFacSuccessfull', { response: response.data, input: data })
        // commit("addAopeToFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setDeleteFacFailed', { data: data, error: error.response })
      })
    },
    deleteRope({ commit, dispatch}, data) {
      console.log('deleteRope', data)
      commit('setDeleteRopeStarted', data)
      // let sendData = {name: data.name, user_id: this.state.auth.userdata.id}
      return axios.delete(API_URL + '/be/facility/rope/remove/'+data, data).then(function (response) {
        console.log('DeleteRope: ', response)
        commit('setDeleteRopeSuccessfull', { response: response.data, input: data })
        // commit("addAopeToFacility", { response: response.data, input: data })
      }).catch(function (error) {
        console.log('failed', error)
        commit('setDeleteRopeFailed', { data: data, error: error.response })
      })
    },

    // addInspection(state, inspection) {
    //   var o = state.facilityList.find(x => x.id === state.inspectingFacilityID)
    //   var facilityName = o.name
    //   var ropeName = state.inspectingRopeName
    //   var ropeType = state.inspectingRopeType
    //   state.inspections.push({
    //     facName: facilityName,
    //     roName: ropeName,
    //     roType: ropeType,
    //     inspectionID: state.inspectingID,
    //     FacilityID: state.inspectingFacilityID,
    //     ropeID: state.inspectingRopeID,
    //     interval: inspection[0],
    //     date: inspection[1],
    //     assessText1: inspection[2],
    //     assessText2: inspection[3],
    //     assessText3: inspection[4],
    //     assessText4: inspection[5],
    //     assessText5: inspection[6],
    //     assessText6: inspection[7],
    //     assessText7: inspection[8],
    //     assessText8: inspection[9],
    //     assess1: inspection[10],
    //     assess2: inspection[11],
    //     assess3: inspection[12],
    //     assess4: inspection[13],
    //     assess5: inspection[14],
    //     assess6: inspection[15],
    //     assess7: inspection[16],
    //     assess8: inspection[17],
    //   })
    // }




  }
})

export default store

// set Auth header if token is available in store
if (store.state.auth.token !== null && store.state.auth.token !== '') {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.auth.token
}

axios.interceptors.response.use(function (response) {
  // console.log('intercepted response', response)
  return response
}, function (error) {
  // console.log('intercepted error', error)
  if (error.response.status === 401 && store.state.auth.valid === true) { // unauthorized
    store.commit('logout')
  }
  return Promise.reject(error)
})

axios.defaults.timeout = 5 * 60 * 1000 // 5 //just for testing timeouts
